(function QTip(Adzuki)
{
	"use strict";

	var QTip = {};

	// private properties
	var overlay_id   = 'qtip-blanket';

	QTip.attachQtip = function attachQtip(el_arg, text_callback_arg, title_callback_arg, position) {
		/**
		 * Done in an attempt to replicate some facebox functionality from excolo and to make it quicker and simpler to re-use
		 * Show qtip when an <a> is clicked. The main content for the qtip dialog will be pulled from a div on the page.
		 *
		 * Required attributes for <a>:
		 * 	href  : The href attribute should contain the id of that div (example: "#qtip-content"). That div will be hidden 99.9% of the time.
		 * 	class : 'qtip-link'
		 *
		 * Optional attributes for <a>
		 * 	data-qtip-title        : to control the title of the qtip.  Otherwise no title will display.
		 * 	data-qtip-hide-overlay : by default, an overlay will be placed over the page content before adding the qtip at a higher z-index
		 * 	                         unless the programmer adds this data attribute to the <a>
		 *
		 * Usage example:
		 *
		 * <div id="qtip-content" class="hidden"></div>
		 * <a href="#qtip-content" class="qtip-link" data-qtip-title="Notification Settings">A Beautiful Link</a>
		 *
		 */
		var el,
		    text_callback,
			title_callback;

		var qtip_my = 'top left';
		var qtip_at = 'bottom right';

		if (typeof el_arg === 'undefined') {
			el = ".qtip-link";
		} else {
			el = el_arg;
		}

		if (typeof text_callback_arg === 'undefined') {
			text_callback = function getText(event, api) {
				var href    = $(this).attr('href'),
					content = $(href).html();
				return content;
			};
		} else {
			text_callback = text_callback_arg;
		}

		if (typeof title_callback_arg === 'undefined') {
			title_callback = function getText(event, api) {
				var content = $(this).data('qtip-title');
				return content;
			};
		} else {
			title_callback = title_callback_arg;
		}

		if (position && position === 'left') {
			qtip_my = 'bottom right';
			qtip_at = 'bottom left';
		}

		$(el).qtip({
				show: {
					event: 'click'
				},
				hide: {
					event: 'click'
				},
				style: {
					classes: 'qtip-bootstrap',
					width  : ($('#qtip-width') === undefined ? '100%' : $('#qtip-width').val())
				},
				content: {
					text : text_callback,
					title: {
						text  : title_callback,
						button: 'Close'
					},
				},
				position: {
					viewport: $('body'),
					my      : qtip_my,
					at      : qtip_at
				},
				events: {
					// By default we are going to show the overlay.  However, if the user included "data-qtip-hide-overlay", we are not going to show one
					show: function showQtipOverlay (event, api) {
						var $clicked_element = $(event.originalEvent.target),
						    hide_overlay     = $clicked_element.data('qtip-hide-overlay') || null;

						if (hide_overlay === null) {
							Adzuki.QTip.fadeInOverlay();
						}
					},
					hide: function hideQtipOverlay (event, api) {
						Adzuki.QTip.fadeOutOverlay();
					}
				},
		})
		.bind('click', function stopClickThru(event) {  // don't allow to go to the href
			event.preventDefault();
			return false;
		});
	};

	// Create an opaque div overlaying the main page content
	QTip.createOverlay = function createOverlay() {
		$('<div id="' + overlay_id + '">')
				.css({
					position       : 'absolute',
					top            : 0,             // $(document).scrollTop()
					left           : 0,
					height         : $(document).height(),
					width          : '100%',
					opacity        : 0.5,
					backgroundColor: 'black',
					zIndex         : 5000
				})
				.appendTo(document.body)
				.hide();
	};

	QTip.fadeInOverlay = function fadeInOverlay() {
		// if overlay div doesn't exist yet, create it before fading in
		if (!$('#' + overlay_id).length) {
			this.createOverlay();
		}
		$('#' + overlay_id).fadeIn();
	};

	QTip.fadeOutOverlay = function fadeOutOverlay() {
		$('#' + overlay_id).fadeOut();
	};

	QTip.showOverlay = function showOverlay() {
		$('#' + overlay_id).show();
	};

	QTip.hideOverlay = function hideOverlay() {
		$('#' + overlay_id).hide();
	};

	QTip.hideAll = function hideAll() {
		$('.qtip').each(function removeEachQTip() {
			$(this).qtip('api').destroy(true);
		});
	};

	// All links with a class of "qtip-link"
	$(document).ready(function documentReady()
	{
		QTip.attachQtip();
	});

	Adzuki.QTip = QTip;

// close function scope and immediately execute function, passing window.Adzuki object as the argument
}(window.Adzuki || {}));
